import {
    FC,
    MouseEvent,
    ReactElement,
    useMemo,
} from 'react'
import { useLocation } from 'react-router'

import { removeSlashAtEndOfString } from '@/helpers/tools'
import { trans } from '@/helpers/trans'

import './ToolTip.scss'

const getBody = (pathname: string): string | null => {
    const myShiftsPath = `/${trans('nav.shifts.link')}/${trans('nav.shifts.myShifts.link')}`
    const openShiftsPath = `/${trans('nav.shifts.link')}/${trans('nav.shifts.openShifts.link')}`
    const absencesPath = `/${trans('nav.absences.link')}/${trans('nav.absences.absences.link')}`
    const leaveOfAbsencesPath = `/${trans('nav.absences.link')}/${trans('nav.absences.leaveOfAbsenceRequests.link')}`
    const tracksPath = `/${trans('nav.tracks.link')}`
    const myExchangesPath = `/${trans('nav.exchanges.link')}/${trans('nav.exchanges.myExchanges.link')}`
    const offeredExchangesPath = `/${trans('nav.exchanges.link')}/${trans('nav.exchanges.offeredExchanges.link')}`
    const documentsPath = `/${trans('nav.documents.link')}`
    const preferencePath = `/${trans('nav.planningPreferences.link')}`
    const profilePath = `/${trans('nav.profile.link')}`

    switch (removeSlashAtEndOfString(pathname)) {
        case myShiftsPath:
            return trans('pages.tooltips.myShifts')
        case openShiftsPath:
            return trans('pages.tooltips.openShifts')
        case absencesPath:
            return trans('pages.tooltips.absences')
        case leaveOfAbsencesPath:
            return trans('pages.tooltips.leaveOfAbsences')
        case tracksPath:
            return trans('pages.tooltips.tracks')
        case myExchangesPath:
            return trans('pages.tooltips.myExchanges')
        case offeredExchangesPath:
            return trans('pages.tooltips.offeredExchanges')
        case documentsPath:
            return trans('pages.tooltips.documents')
        case preferencePath:
            return trans('pages.tooltips.planningPreferences')
        case profilePath:
            return trans('pages.tooltips.profile')
        default:
            return null
    }
}

export const ToolTip: FC = (): ReactElement | null => {
    const location = useLocation()
    const body = useMemo(() => getBody(location.pathname), [location.pathname])

    const onButtonClick = (event: MouseEvent<HTMLButtonElement>): void => {
        // Unlike other browsers, on safari clicking a button won't focus it.
        event.currentTarget.focus()
    }

    if (! body) {
        return null
    }

    return (
        <div className="tooltips">
            <button
                type="button"
                onClick={onButtonClick}
                className="btn-circle btn-circle-small btn-circle-dark tooltips__button"
            >
                ?
            </button>
            <div className="tooltips__text">
                {body
                    .split('\\n')
                    .map((paragraph, index) => <p key={`${index + 1}`}>{paragraph}</p>)}
            </div>
        </div>
    )
}
